module.exports = __webpack_public_path__ + "static/img/qrcode_dialog.bfeb876.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/imgs/themeReading/qrcode_dialog.png
// module id = L3S6
// module chunks = 1